import React from 'react';

interface ViewAnnouncementSectionProps {
  announcement: {
    _id: string;
    title: string;
    message: string;
    createdBy: string;
    date: string;
    priority: string;
    moduleId: string;
  };
  onBack: () => void;
}

const ViewAnnouncementSection: React.FC<ViewAnnouncementSectionProps> = ({ announcement, onBack }) => {
  const getPriorityBadge = (priority: string) => {
    const baseClasses = "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium";
    
    switch (priority) {
      case 'high':
        return `${baseClasses} bg-red-100 text-red-800`;
      case 'medium':
        return `${baseClasses} bg-yellow-100 text-yellow-800`;
      case 'low':
        return `${baseClasses} bg-green-100 text-green-800`;
      default:
        return `${baseClasses} bg-gray-100 text-gray-800`;
    }
  };

  return (
    <div className="p-6 space-y-6">
      <button
        onClick={onBack}
        className="text-blue-600 hover:underline text-sm"
      >
        ← Back to Announcements
      </button>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow border border-gray-200 dark:border-gray-700 p-6 space-y-4">
        <div className="flex justify-between items-start">
          <div className="flex items-center gap-3">
            <span className="text-3xl">📢</span>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">{announcement.title}</h2>
          </div>
          <span className={getPriorityBadge(announcement.priority)}>
            {announcement.priority} priority
          </span>
        </div>

        <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
          {announcement.message}
        </p>

        <div className="flex justify-between items-center text-sm text-gray-500">
          <span>By {announcement.createdBy}</span>
          <span>{announcement.date}</span>
        </div>

        <div className="text-sm text-gray-500">
          <strong>Module:</strong> {announcement.moduleId}
        </div>
      </div>
    </div>
  );
};

export default ViewAnnouncementSection;
